import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { all, isNil, path } from 'ramda';
import { noop } from 'lodash';
import classNames from 'classnames';
import { Manager, Target, Popper } from 'react-popper';
import { preventDefault } from '../../../helpers/utils';
import { SSR } from '../../../helpers/ssr';
const FieldWrapperLayout = props => {
  const {
    id,
    label,
    isValid,
    isDisabled,
    errors,
    className,
    labelClassName,
    formGroupClassName,
    defaultFormGroupClassName,
    hasNoWrapper,
    children,
    renderError,
    renderFieldWrapper,
    fieldWrapperProps
  } = props;
  const isInvalid = !isValid && !isDisabled;
  const hasError = !!path(['length'], errors) && !all(isNil, errors);
  if (hasNoWrapper) {
    return children;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, label && /*#__PURE__*/React.createElement("label", {
    className: labelClassName,
    htmlFor: id
  }, label), /*#__PURE__*/React.createElement("div", {
    className: classNames(defaultFormGroupClassName, formGroupClassName, {
      'has-error': isInvalid && hasError
    })
  }, renderFieldWrapper({
    ...fieldWrapperProps,
    children
  }), isInvalid && hasError && renderError(props)));
};
const MobileFieldWrapperLayout = props => {
  const {
    id,
    label,
    isValid,
    isDisabled,
    errors,
    children,
    className,
    iconClassName,
    onClick,
    renderFieldWrapper,
    fieldWrapperProps,
    isPassengerListDisabled,
    getRef,
    isFocused,
    isForceShownError,
    isChanging,
    onClickIcon
  } = props;
  const isInvalid = !isValid && !isDisabled && !!path(['length'], errors) && !all(isNil, errors);
  const isError = isInvalid && (isFocused && !isChanging || isForceShownError);
  const renderError = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Target, null), isError && /*#__PURE__*/React.createElement(Popper, {
    placement: "top-start",
    modifiers: MobileFieldWrapperLayout.popperModifiers,
    className: "tooltip__form-control"
  }, /*#__PURE__*/React.createElement("span", null, errors))), isError && /*#__PURE__*/React.createElement("div", {
    className: "tooltip__arrow"
  }));
  const renderLabel = /*#__PURE__*/React.createElement("div", {
    className: classNames('flat__label', isInvalid && !isChanging ? 'text-danger' : 'text-muted')
  }, label);
  const renderIcon = iconClassName && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: iconClassName,
    onClick: e => {
      preventDefault(e);
      (onClickIcon || noop)();
    }
  }));
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: classNames('flat__form-control', className),
    onClick: onClick,
    ref: getRef
  }, renderError, renderLabel, /*#__PURE__*/React.createElement("div", {
    className: "flat__form-group"
  }, /*#__PURE__*/React.createElement("div", null, renderFieldWrapper({
    ...fieldWrapperProps,
    children
  })), !isPassengerListDisabled && renderIcon));
};
const preventOverflowModifier = SSR ? {} : {
  boundariesElement: document.body,
  padding: 0
};
MobileFieldWrapperLayout.popperModifiers = {
  preventOverflow: preventOverflowModifier,
  flip: {
    behavior: ['bottom']
  }
};
FieldWrapperLayout.propTypes = {
  labelClassName: PropTypes.string,
  defaultFormGroupClassName: PropTypes.string,
  formGroupClassName: PropTypes.string,
  isValid: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.node,
  isDisabled: PropTypes.bool,
  errors: PropTypes.array,
  hasNoWrapper: PropTypes.bool,
  children: PropTypes.any,
  renderError: PropTypes.func,
  fieldWrapperProps: PropTypes.object,
  renderFieldWrapper: PropTypes.func
};
MobileFieldWrapperLayout.propTypes = {
  iconClassName: PropTypes.string,
  isValid: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool,
  isChanging: PropTypes.bool,
  isForceShownError: PropTypes.bool,
  errors: PropTypes.array,
  // eslint-disable-next-line react/no-unused-prop-types
  hasNoWrapper: PropTypes.bool,
  children: PropTypes.any,
  onClickIcon: PropTypes.func,
  onClick: PropTypes.func,
  fieldWrapperProps: PropTypes.object,
  renderFieldWrapper: PropTypes.func,
  isPassengerListDisabled: PropTypes.bool,
  getRef: PropTypes.func
};
FieldWrapperLayout.defaultProps = {
  labelClassName: 'm-verify-panel__form-label',
  defaultFormGroupClassName: 'form-group',
  // eslint-disable-next-line react/default-props-match-prop-types
  defaultErrorClassName: 'control-label',
  /* eslint-disable */renderError({
    id,
    errors
  }) {
    return /*#__PURE__*/React.createElement("label", {
      className: "error control-label",
      htmlFor: id
    }, errors);
  },
  /* eslint-enable */renderFieldWrapper({
    children
  }) {
    return children;
  },
  fieldWrapperProps: {}
};
MobileFieldWrapperLayout.defaultProps = {
  renderFieldWrapper({
    children
  }) {
    return children;
  },
  fieldWrapperProps: {},
  className: '',
  isForceShownError: false,
  isChanging: false
};
export default class FieldWrapper extends PureComponent {
  static propTypes = {
    isMobileFieldWrapper: PropTypes.bool,
    value: PropTypes.string,
    initialValue: PropTypes.string
  };
  static defaultProps = {
    isMobileFieldWrapper: false
  };
  constructor(props) {
    super(props);
    this.state = {
      isFocused: false,
      isChanging: false
    };
  }
  componentDidMount() {
    if (this.props.isMobileFieldWrapper) {
      this.wrapperElement.addEventListener('focusin', this.onFocusIn);
      this.wrapperElement.addEventListener('focusout', this.onFocusOut);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value || this.props.initialValue !== nextProps.initialValue) {
      this.setState({
        isChanging: true
      });
    }
  }
  componentWillUnmount() {
    if (this.props.isMobileFieldWrapper) {
      this.wrapperElement.removeEventListener('focusin', this.onFocusIn);
      this.wrapperElement.removeEventListener('focusout', this.onFocusOut);
    }
  }
  onFocusIn = () => {
    this.setState({
      isFocused: true,
      isChanging: this.state.isChanging
    });
  };
  onFocusOut = () => {
    this.setState({
      isFocused: false,
      isChanging: false
    });
  };
  getWrapperElement = elm => this.wrapperElement = elm;
  render() {
    const {
      isMobileFieldWrapper
    } = this.props;
    const {
      isFocused,
      isChanging
    } = this.state;
    if (isMobileFieldWrapper) {
      return /*#__PURE__*/React.createElement(MobileFieldWrapperLayout, {
        getRef: this.getWrapperElement,
        isFocused: isFocused,
        isChanging: isChanging,
        ...this.props
      });
    }
    return /*#__PURE__*/React.createElement(FieldWrapperLayout, this.props);
  }
}